module.exports = __webpack_public_path__ + "static/media/benefits6.29883d37.webp";